import React, { useState } from 'react'

import TransactionHistoriesTable from 'Components/CoinHistories/TransactionHistoriesTable';
import CoinHistoriesTable from 'Components/CoinHistories/CoinHistoriesTable';

const CoinHistories = () => {
    const [activeTab, setActiveTab] = useState('purchases');
    return (
        <>
            <div className="flex border-b mb-4">
                <button
                    className={`px-4 py-2 text-sm font-medium ${activeTab === 'purchases' ? 'border-b-2 border-[#c51369] text-[#c51369]' : 'text-gray-500'
                        }`}
                    onClick={() => setActiveTab('purchases')}
                >
                    Purchase History
                </button>
                <button
                    className={`px-4 py-2 text-sm font-medium ${activeTab === 'transactions' ? 'border-b-2 border-[#c51369] text-[#c51369]' : 'text-gray-500'
                        }`}
                    onClick={() => setActiveTab('transactions')}
                >
                    Transaction History
                </button>
            </div>
            {activeTab === 'purchases' ? (
                <CoinHistoriesTable />
            ) : (
                <TransactionHistoriesTable />
            )}
        </>
    )
}

export default CoinHistories